// Flattens a tag's full descendant tree (any depth, not just direct
// children) into a depth-first list of {tag, depth} - depth 1 is a direct
// child, 2 a grandchild, and so on. Needed because this forum's category
// hierarchy sometimes goes 3 levels deep (e.g. "Rédactions" -> "Liens" ->
// "Ascomycètes", migrated as-is from phpBB - see migration/02_tags.php),
// but flarum-tags' own model only distinguishes "primary" from "has a
// parent", with no concept of how deep that nesting goes.
//
// `compareFn` sorts each tag's own children before recursing into them -
// left up to the caller since different listings order forums differently
// (by activity in the header menu, alphabetically on the /tags page).
export default function collectDescendants(tags, parent, compareFn, depth) {
  if (depth === void 0) {
    depth = 1;
  }
  const children = tags.filter(tag => tag.parent() === parent).sort(compareFn);
  return children.flatMap(tag => [{
    tag,
    depth
  }, ...collectDescendants(tags, tag, compareFn, depth + 1)]);
}
flarum.reg.add('champis-forum', 'forum/utils/tagTree', collectDescendants);